import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { HomeOutlined } from '@mui/icons-material'
import { Box, IconButton, Tooltip } from '@mui/material'

import { images } from '~assets/images'
import { Avatar } from '~components/common'
import EnvironmentIndicator from '~components/common/EnvironmentIndicator'
import Image from '~components/common/Image'
import { RootState } from '~redux/rootReducer'
import { IdentityId } from '~types'

interface TopHeaderProps {}

export const HomeAndSettingsButton: React.FC = () => {
  const user = useSelector((state: RootState) => state?.auth.user)
  const navigate = useNavigate()

  return (
    <Box className='flex-v-align' gap={1}>
      <Tooltip title='Home' placement='bottom'>
        <IconButton onClick={() => navigate(`/my-cases`)}>
          <HomeOutlined />
        </IconButton>
      </Tooltip>
      <Tooltip title='Settings' placement='bottom'>
        <IconButton onClick={() => navigate(`/account`)}>
          {user && <Avatar identityId={user.identity_id as IdentityId} size={'25px'} />}
        </IconButton>
      </Tooltip>
    </Box>
  )
}

const TopHeader: React.FC<TopHeaderProps> = () => {
  return (
    <>
      <EnvironmentIndicator position='bottom-right' />
      <Box
        className='flex-v-align'
        sx={{
          backgroundColor: 'white',
          borderBottom: '1px solid #e0e0e0',
          p: 3,
          height: '8vh',
          position: 'sticky',
          top: 0,
        }}
        gap={2}
      >
        <Box
          sx={{ cursor: 'pointer' }}
          onClick={() => (window.location.href = `https://polimorphic.com`)}
        >
          <Image src={images.textLogo} alt='Polimorphic logo' size={'120px'} />
        </Box>
        <Box className='flex-grow' />
        <HomeAndSettingsButton />
      </Box>
    </>
  )
}

export default TopHeader
